import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import {
  TABLE_ACCOUNTS,
  TABLE_PIPELINE_DEALS,
  TABLE_PIPELINE_PROSPECTS,
  TABLE_PROSPECTS
} from '../../../../state_manager/globals.ts'

import Button from '../../Button.jsx'
import { RIBBON_CTA_CLASS } from './ribbonCta.ts'

interface AddButtonProps {
  addButtonLabel: string
  moduleKey: string
  subModuleKey?: string
  navigateState?: Record<string, unknown>
}

const AddButton = ({ addButtonLabel, moduleKey, subModuleKey, navigateState }: AddButtonProps) => {
  const navigate = useNavigate()

  const handleAddClick = () => {
    if (moduleKey === TABLE_PROSPECTS) {
      moduleKey = 'fundraising'
    }

    if (moduleKey === TABLE_ACCOUNTS) {
      moduleKey = 'companies'
    }

    const navOptions = navigateState ? { state: navigateState } : undefined

    if (subModuleKey === TABLE_PIPELINE_DEALS) {
      return navigate(`/${moduleKey}/pipeline/forms/drawer/new`, navOptions)
    }

    if (subModuleKey === TABLE_PIPELINE_PROSPECTS) {
      return navigate('/fundraising/pipeline/forms/drawer/new', navOptions)
    }

    navigate(`/${moduleKey}/forms/drawer/new`, navOptions)
  }

  return (
    // Pinned to the legacy blue (owner decision 2026-08-12): this button sits
    // ON the brand-blue gradient ribbon, so it must not follow the brand
    // colorPrimary token (#4C90E9 would melt into the ribbon). Keeps the
    // exact pre-theme-change look.
    <Button
      variant='primary'
      icon={<FontAwesomeIcon icon={faPlus} />}
      onClick={handleAddClick}
      className={RIBBON_CTA_CLASS}
    >
      {addButtonLabel}
    </Button>
  )
}

export default AddButton
